import { Link } from "react-router-dom";
import { ShieldCheck, Lock } from "lucide-react";

/**
 * Badge visual de cumplimiento normativo.
 * Variantes: 'full' (footer landing), 'compact' (booking, profile), 'inline' (texto pequeño).
 */
export default function ComplianceBadge({ variant = "full", dark = false }) {
  const items = [
    { label: "RGPD", title: "Reglamento General de Protección de Datos (UE) 2016/679" },
    { label: "LOPDGDD", title: "Ley Orgánica 3/2018 de Protección de Datos" },
    { label: "Ley 41/2002", title: "Autonomía del paciente" },
    { label: "REMPE", title: "Receta Médica Privada Electrónica" },
  ];

  if (variant === "inline") {
    return (
      <span className={`inline-flex items-center gap-1.5 text-xs ${dark ? "text-white/70" : "text-muted-foreground"}`} data-testid="compliance-inline">
        <Lock className="w-3 h-3" /> RGPD · LOPDGDD · Ley 41/2002
      </span>
    );
  }

  if (variant === "compact") {
    return (
      <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs border ${dark ? "border-white/20 bg-white/5 text-white/80" : "border-emerald-200 bg-emerald-50 text-emerald-800"}`} data-testid="compliance-compact">
        <ShieldCheck className="w-3.5 h-3.5" />
        <span className="font-medium">Cumple RGPD · LOPDGDD · Ley 41/2002</span>
      </div>
    );
  }

  // full
  return (
    <div className={`rounded-2xl border ${dark ? "border-white/10 bg-white/5" : "border-emerald-100 bg-gradient-to-br from-emerald-50 to-white"} p-5`} data-testid="compliance-full">
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${dark ? "bg-emerald-500/20" : "bg-emerald-100"}`}>
          <ShieldCheck className={`w-5 h-5 ${dark ? "text-emerald-300" : "text-emerald-700"}`} />
        </div>
        <div className="min-w-0">
          <div className={`font-display font-semibold text-sm ${dark ? "text-white" : "text-emerald-900"}`}>
            Servicio sanitario conforme a la normativa europea y española
          </div>
          <div className={`text-xs mt-1 ${dark ? "text-white/60" : "text-emerald-800/80"}`}>
            Datos sanitarios protegidos. Receta electrónica con validez legal. Telemedicina con consentimiento informado.
          </div>
          <div className="mt-3 flex flex-wrap gap-1.5">
            {items.map((i) => (
              <span
                key={i.label}
                title={i.title}
                className={`text-[10px] font-mono uppercase tracking-wider px-2 py-1 rounded ${dark ? "bg-white/10 text-white/80" : "bg-white border border-emerald-200 text-emerald-700"}`}
              >
                {i.label}
              </span>
            ))}
          </div>
          <Link
            to="/privacidad"
            className={`inline-block mt-3 text-xs font-medium underline ${dark ? "text-emerald-300" : "text-emerald-700"}`}
          >
            Ver política de privacidad →
          </Link>
        </div>
      </div>
    </div>
  );
}
